import React, { Component } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter, Col, Container, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink, FormFeedback } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class Setting extends Component {
  constructor(props) {
    super(props)

    var pathname = this.props.location.pathname
    var paths = pathname.split("/")
    var idx = paths[paths.length - 1]
    var caregiver = new Api().cache(idx)
    console.log(caregiver)
    if (caregiver == undefined) {
      caregiver = {
        id : null,
        first_name : "",
        last_name : "",
        email : "",
        phone : "",
        sms : "",
      }
    }

    this.state = {
      id: caregiver.id,
      fname: caregiver.first_name,
      lname: caregiver.last_name,
      email: caregiver.email,
      phone: caregiver.phone,
      sms: caregiver.sms,
      msg: ""
    }
  }

  logout() {
    var api = new Api()
    api.unmount()
    api.jump('/')
  }

  save() {
    var api = new Api()
    // api.save(this.state.id, this.state.name, this.state.phone, this.state.sms, (succ, ret) => {
    //   this.setState({
    //     msg: ret
    //   })
    // })
    api.updateCaregiver(this.state.id, this.state.fname, this.state.lname, this.state.email, this.state.phone, this.state.sms, (succ, ret) => {
      alert("Save Successfully");
      api.jump("list");
    });
  }

  render() {
    return (

      <div className="app align-items-center mcg">

        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
            <Menu/>
              <CardHeader  className="titlehead">
                  <h1 className="mb-0 my-2">My Contacts</h1>
                  <p className="text-center mb-0">Please fill out all fields then click Save Changes. Phone numbers should be numbers only no formatting and please enter the numbers that you can dial out successfully with your cell phone.</p>
              </CardHeader>
              <CardBody className="pageSetting login-form py-0">
                
                <Row>
                  <Col lg="12" className="leftbox pt-0">
                    {/*<Row className="subheader">*/}
                      {/*
                      <Col sm="6" className="text-center">
                        <NavLink className="inline-link" href="/#/changepw">
                          <Button outline  className="px-4 btn-outline" color="primary">Change Password</Button>
                        </NavLink>
                      </Col>
                      */}
                      {/*<Col sm="6" className="text-center">*/}
                        {/* <NavLink className="inline-link" href="/#/login"> */}
                        {/*<Button outline  className="px-4 btn-outline" color="primary" onClick={this.logout.bind(this)}>Log-Out</Button>*/}
                        {/* </NavLink> */}
                      {/*</Col>*/}
                    {/*</Row>*/}
                    <div className="rb-inner" style={{ paddingTop: '2rem' }}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Firstname*" value={this.state.fname} autoComplete="firstname" onChange={(evt) => { this.setState({fname: evt.target.value}); }} required/>
                        <Input type="text" placeholder="Lastname*" value={this.state.lname} autoComplete="lastname" onChange={(evt) => { this.setState({lname: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-envelope" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="email" placeholder="Email Address*" value={this.state.email} autoComplete="emailaddress" onChange={(evt) => { this.setState({email: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-phone"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="phone" placeholder="Voice Number [Format : +{country code}{phone number}]" value={this.state.phone} autoComplete="CellNumber" onChange={(evt) => { this.setState({phone: evt.target.value}); }}/>
                        {/* <Input type="number" placeholder="Voice Call Number " autoComplete="VoiceCallNumber " /> */}
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-phone"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="phone" placeholder="Text Number [Format : +{country code}{phone number}]" value={this.state.sms} autoComplete="CellNumber" onChange={(evt) => { this.setState({sms: evt.target.value}); }}/>
                        {/* <Input type="number" placeholder="Voice Call Number " autoComplete="VoiceCallNumber " /> */}
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      {/*
<InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-clock-o"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" name="select" id="select" className="minimal">
                          <option value="0">Time Zone</option>
                          <option value="1">Option #1</option>
                          <option value="2">Option #2</option>
                          <option value="3">Option #3</option>
                        </Input>
                        <Input type="select" name="select" id="select">
                          <option value="0">Daylight Savings Time? </option>
                          <option value="1">No DST</option>
                          <option value="2">Use DST</option>
                        </Input>
                      </InputGroup>
                      */}
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                        {this.state.msg}
                      </div>
                      {/*
                        <div className="borderbox">
                        <FormGroup check className="checkbox">
                          <Input className="form-check-input" type="checkbox" id="checkbox1" name="checkbox1" value="option1" />
                          <Label check className="form-check-label" htmlFor="checkbox1" style={{fontWeight:'normal'}}>Disable Alert All</Label>
                        </FormGroup>
                      </div>
                      */}
                      <div className="wraning-msg"></div>
                      <div className="text-center">
                          <Button color="primary" className="mb-3 mt-3 px-4 btn-brand" onClick={this.save.bind(this)}>Save Changes</Button>
                          {/*<NavLink className="inline-link" href="/#/list">
                            <Button color="primary" outline className="mb-3 mt-3 px-4 btn-outline">Cancel</Button>
                          </NavLink>*/}
                      </div>
                      {/*
                        <div className="tips-msg pb-0">
                        For International Phone numbers (non U.S) please <NavLink href="#" className="inline-link">Click Here for Examples</NavLink>.<br /> 
                        Example showing UK: change this 07911 123456 to 447911123456
                      </div>
                      */}
                    </div>
                  </Col>
                  {/*
<Col lg="4" className="rightbox termsbox">
                    <div className="font-weight-bold stitle">Your Plan B Features are now active.</div>
                    <ol className="terms pb-4">
                      <li>120 Messages per month.</li>
                      <li>5 Additional Contacts have been added for a total of 10</li>
                      <li>Disable Alert All. This checkbox located at the bottom of the Settings Page, Use this if Alexa misunderstands you and defaults to Alert All. Send Help and Alert Everyone will still work.</li>
                      <li>Multi lingual Alerts: Spanish, French, Swedish, German, Portuguese and Italian. Need more, let us know. These language options can be selected from a drop down list for each contact you have entered on your Contact page.</li>
                    </ol>
                  </Col>
                  */}
                </Row>
              </CardBody>

            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"3"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default Setting;



// WEBPACK FOOTER //
// ./src/views/Pages/Mysetting/Setting.js